import { render } from "./group_rewards.vue?vue&type=template&id=7d9a0dca"
import script from "./group_rewards.vue?vue&type=script&lang=js"
export * from "./group_rewards.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__